// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3vWY-","colMaxWidth":"Table_colMaxWidth__2bDa1"};